require('angular')
require('angular-route')
require('../../core/translation/translation-module')
require('../components/common-wrapper/common-wrapper-module')

# Load Css
require('../../../sass/web/html/_term-of-use.scss')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-common-wrapper'
]
angular.module 'gnp-app-legal', modules
  .config ['$routeProvider', '$translateProvider', ($routeProvider, $translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')

    $routeProvider.when '/legal',
      controller: 'LegalCtrl'
      template: '<div ng-include="templateUrl"></div>'
      title: '_LEGAL.TITLE'
  ]
  .controller 'LegalCtrl', ['$scope', '$translate', ($scope, $translate) ->
    $scope.templateUrl = "templates/legal/index.#{$translate.use()}.html"
  ]




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/legal/legal-module.coffee